module.exports = __webpack_public_path__ + "img/mascot-logo.c8e66aaf.png";